import React from 'react';
import { Layout, Button, Space, Avatar, Dropdown, Typography, Grid } from 'antd';
import {
    MenuUnfoldOutlined,
    MenuFoldOutlined,
    UserOutlined,
    LogoutOutlined
} from '@ant-design/icons';
import { useLocation, useNavigate } from 'react-router-dom';

const { Header: AntHeader } = Layout;
const { Text } = Typography;

const Header = ({ collapsed, setCollapsed }) => {
    const user = JSON.parse(localStorage.getItem('user') || '{}');
    const location = useLocation();
    const navigate = useNavigate();
    const screens = Grid.useBreakpoint();
    const isMobile = !screens.md;

    const getPageTitle = (path) => {
        if (path === '/') return 'Dashboard';
        if (path.startsWith('/customers')) return 'Customers';
        if (path.startsWith('/orders')) return 'Orders';
        if (path.startsWith('/leads')) return 'Leads';
        if (path.startsWith('/inventory')) return 'Inventory';
        if (path.startsWith('/vendors')) return 'Vendors';
        if (path.startsWith('/vendor-agreement')) return 'Vendor Agreement';
        if (path.startsWith('/channel-partners')) return 'Channel Partners';
        if (path.startsWith('/purchases')) return 'Purchases';
        if (path.startsWith('/sales')) return 'Sales Invoices';
        if (path.startsWith('/proforma')) return 'Proforma Invoices';
        if (path.startsWith('/payment-milestones')) return 'Payment Milestones';
        if (path.startsWith('/msedcl')) return 'MSEDCL Documents';
        if (path.startsWith('/quotations')) return 'Quotations';
        if (path.startsWith('/user-management')) return 'User Management';
        if (path.startsWith('/reports')) return 'Reports';
        return 'Profit Pannels';
    };

    const handleLogout = () => {
        localStorage.removeItem('token');
        localStorage.removeItem('user');
        navigate('/login');
    };

    const userMenuItems = [
        {
            key: 'profile',
            label: 'My Profile',
            icon: <UserOutlined />,
        },
        {
            type: 'divider',
        },
        {
            key: 'logout',
            label: 'Logout',
            icon: <LogoutOutlined />,
            danger: true,
            onClick: handleLogout,
        },
    ];

    return (
        <AntHeader
            style={{
                padding: 0,
                background: '#fff',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'space-between',
                paddingRight: isMobile ? '8px' : '24px',
                boxShadow: '0 2px 4px rgba(0,0,0,0.05)',
                width: '100%',
            }}
        >
            <div style={{ display: 'flex', alignItems: 'center', flex: 1, minWidth: 0, paddingRight: '8px' }}>
                {React.createElement(collapsed ? MenuUnfoldOutlined : MenuFoldOutlined, {
                    className: 'trigger',
                    onClick: () => setCollapsed(!collapsed),
                    style: {
                        fontSize: '18px',
                        padding: '0 16px',
                        cursor: 'pointer',
                        transition: 'color 0.3s',
                        flexShrink: 0,
                    },
                })}
                <Text
                    strong
                    style={{
                        fontSize: '16px',
                        whiteSpace: 'nowrap',
                    }}
                >
                    {getPageTitle(location.pathname)} {!isMobile && <span style={{ opacity: 0.7, fontWeight: 'normal' }}>| {user.role || 'System Admin'}</span>}
                </Text>
            </div>

            <Space size="small" style={{ flexShrink: 0 }}>
                <Dropdown menu={{ items: userMenuItems }} placement="bottomRight">
                    <Space style={{ cursor: 'pointer' }}>
                        <Avatar icon={<UserOutlined />} />
                        {!isMobile && (
                            <Text
                                style={{
                                    display: 'inline-block',
                                    maxWidth: '150px',
                                    whiteSpace: 'nowrap',
                                    overflow: 'hidden',
                                    textOverflow: 'ellipsis',
                                    verticalAlign: 'middle',
                                }}
                            >
                                {user.fullName || 'User'}
                            </Text>
                        )}
                    </Space>
                </Dropdown>
            </Space>
        </AntHeader>
    );
};

export default Header;
